import React, { Component } from 'react';
import './Ad.css';

const clientId = 'ca-pub-7709048971046465';

class Ad extends Component {

	render() {

		let banner = null;
		let localClass = '';

		if(location.hostname !== "localhost") {
			if(this.props.type==='leaderboard') {
				banner = (
					<div>

					</div>
				);
			}
			if(this.props.type==='medium-rectangle') {
				banner = (
					<div>
						
					</div>
				);
			}
		} else {
			banner = this.props.type;
			localClass = ' local';
		}

		return (
			<div className={'Ad ' + this.props.type + localClass}>
				{banner}
			</div>
		);
	}
}

export default Ad;



// WEBPACK FOOTER //
// ./src/components/Ad.js